import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

export const useGetProfileStyle = (enabled = false) => {
  return useQuery({
    queryKey: ['profile-style'],
    queryFn: () => api.fetchProfileStyle(),
    enabled,
    staleTime: 30_000,
    retry: false,
  });
};

/**
 * Query to check if user profile is ready
 * @param {boolean} enabled - Whether the query should be active
 * @param {function} onSuccess - Callback when profile check is successful
 * @param {function} onError - Callback when profile check fails
 */
export const useCheckProfile = (enabled = true, onSuccess, onError) => {
  return useQuery({
    queryKey: ['check-profile'],
    queryFn: async () => {
      const result = await api.checkProfileReady();
      // If there's an error or no profile, we'll handle it in the component
      // Don't throw here, return the result as-is
      return result;
    },
    enabled,
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onError: (error) => {
      console.error('Profile check error:', error);
      if (onError) onError(error);
    },
    retry: false, // Don't retry on errors
    staleTime: 0,
    cacheTime: 0,
    // Treat any error as profile not created
    useErrorBoundary: false,
  });
};
